import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var BusinessMarketingIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    d: "M40.5391 26.4686L39.8999 28.8877C37.2173 39.0417 26.9264 45.0674 16.9147 42.3467C6.90292 39.626 0.961497 29.189 3.64414 19.0351C6.32678 8.88113 16.6176 2.85534 26.6294 5.57608L29.0146 6.22428L24.7962 22.1913L40.5391 26.4686ZM23.5569 7.52908C15.6864 6.6397 8.14178 11.6878 6.02939 19.6833C3.69973 28.5012 8.85938 37.5648 17.5538 39.9276C25.4374 42.07 33.5202 37.9674 36.696 30.6099C37.0227 29.8531 37.2974 29.0619 37.5147 28.2395L24.1575 24.6097C22.8402 24.2517 22.058 22.8792 22.4109 21.5431L25.9903 7.9952C25.1794 7.77484 24.3664 7.62055 23.5569 7.52908Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    d: "M30.2406 19.0029L42.4526 22.3216C43.1155 15.7025 39.4963 9.34475 33.5131 6.61729C32.2866 11.2608 30.9902 16.1664 30.2406 19.0029ZM42.003 24.7922C43.3203 25.1502 44.6949 24.3564 44.8637 22.9838C45.8447 15.0093 41.4529 7.29424 34.1532 4.16845C32.8967 3.63039 31.532 4.43896 31.1791 5.77516C29.9373 10.4767 28.6147 15.4814 27.8547 18.357C27.5016 19.6931 28.2817 21.0634 29.5991 21.4214L42.003 24.7922Z"
  }));
});
BusinessMarketingIcon.displayName = 'BusinessMarketingIcon';
BusinessMarketingIcon.defaultProps = {
  'aria-label': 'Marketing'
};
export default BusinessMarketingIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/BusinessMarketingIcon/index.js
// module id = 1990
// module chunks = 12